<template>
  <div class="lbv-search animated fadeIn roundedCard">
    <b-card>
      <div class="lbv-header-wrapper">
        <h1 class="lbv-page-title">
          Tenant Group
        </h1>
        <button
          id="addTenant"
          v-b-modal.newTenantGroupModal
          type="submit"
          class="btn btn-primary addTenant"
        >
          Add Tenant Group
        </button>
      </div>
      <b-table
        :items="tenantGroupList"
        :fields="tenantGroupFields"
        striped
      >
        <template
          slot="tenant_group_name"
          slot-scope="data"
        >
          <span
            v-if="isChild(data)"
            class="child-arrow"
          >↳</span>
          <span
            v-if="!isForm(data) && isChild(data)"
            class="tenant-label"
          >{{ data.value }} </span>
          <b-link
            v-else-if="!isForm(data)"
            class="tenant-label deviceLink"
            @click="editTenantName(data)"
          >
            {{ data.value }}
          </b-link>
          <span
            v-if="isChild(data) && !isForm(data)"
            class="icon-close sub-icon-close"
            @click="deleteChild(data)"
          />
          <span
            :class="determineExpandClass(data)"
            @click="expandItem(data)"
          />
          <span
            :class="determineDeleteClass(data)"
            @click="deleteItem(data)"
          />
          <div
            v-if="isForm(data)"
            class="inline-tenant-form"
          >
            <b-form-select
              id="selectTenants"
              v-model="selectedTenant"
            >
              <option
                disabled
                value="null"
              >
                Select tenant...
              </option>
              <option
                v-for="tenant in tenants"
                v-bind="$attrs"
                :key="tenant.id"
                :value="{ id: tenant.id }"
                @option="$emit('option', $event.target.value)"
              >
                {{ tenant.name }}
              </option>
            </b-form-select>
            <b-button
              size="sm"
              variant="primary"
              @click="subscribeTenant(data)"
            >
              Add Tenant
            </b-button>
          </div>
        </template>
      </b-table>
      <b-modal
        id="newTenantGroupModal"
        ref="newTenantGroupModal"
        title="New Tenant Group"
        ok-variant="primary"
        ok-title="Save"
        @ok="createTenantGroup"
        @show="clearInput"
      >
        <div class="col-md-12">
          <b-form-group
            horizontal
            label="Tenant Group Name:"
            :label-cols="4"
          >
            <b-form-input
              v-model="newGroupName"
              class="col-md-8 full-width "
              type="text"
            />
          </b-form-group>
        </div>
      </b-modal>
      <b-modal
        id="renameTenantGroupModal"
        ref="renameTenantGroupModal"
        title="Rename Tenant Group"
        ok-variant="primary"
        ok-title="Save"
        @ok="renameTenantGroup"
      >
        <div class="col-md-12">
          <b-form-group
            horizontal
            label="Tenant Group Name:"
            :label-cols="4"
          >
            <b-form-input
              v-model="updateGroup.tenant_group_name"
              class="col-md-8 full-width "
              type="text"
            />
          </b-form-group>
        </div>
      </b-modal>
    </b-card>
  </div>
</template>

<script>
import tenantGroupsMixin from '../mixins/tenantGroupsMixin'

export default {
  name: 'TenantGroups',
  mixins: [tenantGroupsMixin]
}
</script>
<style media="screen">
.lbv-search .full-width {
  width: 100% !important;
  max-width: 100%;
}
h1.lbv-page-title {
  display: inline-block;
  border: none;
}

.lbv-header-wrapper {
  border-bottom: 1px solid #c2cfd6;
}

#addTenant {
  float: right;
}

.lbv-search .custom-td-width{

  width: 100px;
  max-width: 100px;
}

.lbv-search .tenant-label{
  display: inline-block;
  width: 200px;
  max-width: 200px;
}

.lbv-search .icon-plus, .lbv-search .icon-minus {
  color: #22D3C5;
  cursor: pointer;
}

.lbv-search .master-icon-close, .lbv-search .sub-icon-close {
  color: #f86c6b;
  cursor: pointer;
}

.lbv-search .master-icon-close {
  float: right;
}
.lbv-search .sub-icon-close {
  margin-left: -50px
}

#selectTenants {
  width: 300px;
}

.inline-tenant-form {
  display: inline-block;
}

.child-arrow {
  font-size: 1.3rem;
}

</style>
